import React from "react";
import { Button } from "antd";

interface CustomButtonProps {
  imageSrc: string;
  primaryText: string;
  secondaryText: string;
  onClick?: () => void;
  className?: string;
}

const CustomButton: React.FC<CustomButtonProps> = ({
  imageSrc,
  primaryText,
  secondaryText,
  onClick,
  className = "",
}) => {
  return (
    <Button
      onClick={onClick}
      className={`flex items-center bg-black text-white rounded-[6px] ${className}`}
      style={{
        border: "1px",
        backgroundColor: "black",
        color: "white",
        transition: "none",
        height: "40px",
        width: "120px",
        padding: "0",
      }}
      onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "black")}
      onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "black")}
    >
      <img
        src={imageSrc}
        alt="Icon"
        style={{
          width: "20px",
          height: "24px",
        }}
      />

      <div className="flex flex-col items-start ml-2">
        <span className="text-[9px] font-medium text-white text-ellipsis overflow-hidden">
          {primaryText}
        </span>
        <span className="text-[14px] font-medium text-white text-ellipsis overflow-hidden">
          {secondaryText}
        </span>
      </div>
    </Button>
  );
};

export default CustomButton;
